import { lazy } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import config from 'configs';
import { isMobileMode, openPopup } from 'store/actions';
import { CHANNEL_CREATION, REQUEST_CHANNEL_CREATE } from 'constants/popups';
import { getCurrentTheme } from 'store/selectors';
import { useMount } from 'utils/hooks';
import viewSwitcher from 'utils/viewSwitcher';
import withSuspense from 'utils/withSuspense';
import createSchema from 'utils/createColorSchema';

const AsianView = withSuspense(lazy(() => import('./asianLayout')));
const ClassicView = withSuspense(lazy(() => import('./classicLayout')));

const MOBILE_MAX_SIZE = 1025;

const Layout = () => {
  const dispatch = useDispatch();

  const currentTheme = useSelector(getCurrentTheme);
  const themeColors = config.skinnings[config.currentSkin][currentTheme].colors;

  const checkMobileMode = () => {
    const isMobileWidth = window.innerWidth < MOBILE_MAX_SIZE;

    dispatch(isMobileMode(isMobileWidth));
  };

  // eslint-disable-next-line no-unused-vars
  const runDevelopmentTestCode = () => {
    console.log('runDevelopmentTestCode');
    dispatch(openPopup(CHANNEL_CREATION));
    setTimeout(() => dispatch(openPopup(REQUEST_CHANNEL_CREATE)), 400);
  };

  createSchema(themeColors);

  useMount(() => {
    checkMobileMode();

    window.addEventListener('resize', checkMobileMode);

    // runDevelopmentTestCode();

    return window.addEventListener('resize', checkMobileMode);
  });

  return viewSwitcher(ClassicView, AsianView, { currentTheme });
};

export default Layout;
